/**
 * @module enum
 */
export enum FriendType {
    /**
     * 单向好友
     */
    V2TIM_FRIEND_TYPE_SINGLE = 1,
    /**
     * 双向好友
     */
    V2TIM_FRIEND_TYPE_BOTH = 2,
}
